
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { BrowserRouter as Router, useNavigate,useParams  } from "react-router-dom";

//dvr login    http://202.175.83.51:8088/StandardApiAction_login.action?account=minkee_gps&password=000000
//dvr example  http://202.175.83.51:8088/808gps/open/player/video.html?lang=en&vehiIdno=AK1213&account=minkee_gps&password=000000&index=2&close=10
//dvr example2 http://202.175.83.51:8088/808gps/open/player/video.html?lang=en&jsession=cf6b70a3-c82b-4392-8ab6-bbddce336222&vehiIdno=AK1213&index=2&close=10
//dvr img      http://202.175.83.51:8088/StandardApiAction_capturePicture.action?jsession=649b7687-6792-41a2-b9be-7806f2a0d3fa&Type=1&DevIDNO=50000&Chn=1
//export const Server = "http://www.jdts.biz:8082"
//export const Server = "http://192.168.8.150:8083"
//export const Server = "http://www.jdts.biz:5808"
//export const Server = "https://gpshk.mapking.com:2089"
export const Server2 = "/CitySchoolBusHandler/API/CitySchoolBusHandler.ashx"
//export const Server3 = "https://gpshk.mapking.com:2043/"
//export const DvrServer = "http://202.175.83.51:8088/808gps/open/player/video.html?lang=en"

// export const Server = "http://gpshk.mapking.com:2040"
// export const Server3 = "http://gpshk.mapking.com:2070"
// export const newServer = "https://gps.citymotors.com.hk:2043"

// export const Server = "https://gps.citymotors.com.hk:2041"//2041
// export const Server3 = "http://www.jdts.biz:8089"
// export const newServer = "https://gps.citymotors.com.hk:2043"

// export const Server = "https://gps.citymotors.com.hk:2041"//2041
// export const Server3 = "https://gps.citymotors.com.hk:2043"
// export const newServer = "https://gps.citymotors.com.hk:2043"

export const Server = "https://gps.citymotors.com.hk:2041"//2041
export const Server3 = "https://gps.citymotors.com.hk"
export const newServer = "https://gps.citymotors.com.hk"

export const NumericOnly= (e) => { //angka only
    const reg = /^[0-9\b]+$/
    let preval=e.target.value
    if (e.target.value === '' || reg.test(e.target.value)) return true
    else e.target.value = preval.substring(0,(preval.length-1))
}

export const AlphabetOnly= (e) => { //angka only 
    //正規表示式
    const reg = /^[A-Za-z\b]+$/
    let preval=e.target.value
    if (e.target.value === '' || reg.test(e.target.value)) return true
    else e.
    target.value = preval.substring(0,(preval.length-1))
}
export default function fn(){
    console.log("HIHI")
}

export const aaa = () => {
    console.log("HIHI")
}

export let a = "HIHI"
export function HandleLogoutClick(){
    //let history = useHistory();
    //history.push("/");
    //window.location.replace(Server)

    document.location.replace(Server3+"#/uuid/"+localStorage.getItem("IMEI"))
    window.location.replace(Server3+"#/uuid/"+localStorage.getItem("IMEI"))

    //document.location.replace(Server4)
    //window.location.replace(Server4)

    //window.location.replace("http://192.168.8.150:8083/")
    //window.location.replace("http://127.0.0.1:8083/")
  }

  export function redirectToNew(IMEI){
    //let history = useHistory();
    //history.push("/");
    //window.location.replace(Server)
    document.location.replace(newServer+"#/uuid/"+IMEI)
    window.location.replace(newServer+"#/uuid/"+IMEI)
    //window.location.replace("http://192.168.8.150:8083/")
    //window.location.replace("http://127.0.0.1:8083/")
  }
export let logoutButton = <Button style={{marginLeft:3,marginRight:3}} variant="contained" color="primary" onClick={HandleLogoutClick} >Logout</Button>

export function download(data, filename, type) {
    // Decode Base64 string
    const decodedData = window.atob(data);

    // Create UNIT8ARRAY of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);

    // Insert all character code into uInt8Array
    for (let i = 0; i < decodedData.length; ++i) {
        uInt8Array[i] = decodedData.charCodeAt(i);
    }
    var file = new Blob([uInt8Array], {type: type});
    if (window.navigator.msSaveOrOpenBlob) // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
    else { // Others
        var a = document.createElement("a"),
                url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);  
        }, 0); 
    }
}

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    root2: {
      margin: 0,
      padding: theme.spacing(2),
      textAlign: "center",
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export const DialogTitle = (props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography style={{
        margin: 0,
        padding: 15,
        textAlign: "center",
      }} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" style={
            {
              position: 'absolute',
              right: 5,
              top: 5,
              color: "#888888",
            }
          } onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  };

export const DialogContent = (MuiDialogContent);

export const DialogActions = (MuiDialogActions);

export function LoadingDialog(open){
    if(open){
        return (
            <Dialog
                open={true}
                onClose={null}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                <DialogTitle id="alert-dialog-title"><Typography align="center"  style={{width:200}}>Loading...</Typography></DialogTitle>
            </Dialog>
        ); 
    }else{
        return(null);
    }
}

export function ConfirmDialog(open,title,handleConfirmtCancel,handleConfirmtOK){
    if(open){
        return(
            <Dialog
            open={true}
            onClose={null}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title" align="center">{title}</DialogTitle>
            <DialogActions>
                <Button onClick={handleConfirmtCancel} color="primary">Cancel</Button>
                <Button onClick={handleConfirmtOK} color="primary" autoFocus>OK</Button>
            </DialogActions>
            </Dialog>
        );
    }else{
        return(null);
    }
}
export function OneButtonConfirmDialog(open,title,handleConfirmtOK){
    if(open){
        return(
            <Dialog
            open={true}
            onClose={null}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title" align="center">{title}</DialogTitle>
            <DialogActions>
                <Button onClick={handleConfirmtOK} color="primary" autoFocus>OK</Button>
            </DialogActions>
            </Dialog>
        );
    }else{
        return(null);
    }
}

export function ErrorDialog(errorNo,open,stateRefresh){
  //let navigate = useNavigate();
    if(open){
        var errorString = "Error"
        if(errorNo === "400"){
            errorString = "Wrong Password"
        }else if(errorNo === "201"){
          errorString = "Login timeout,please login again."
        }else if(errorNo === "401"){
            errorString = "Error"
        }
        return (
            <Dialog
                open={true}
                onClose={null}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                <DialogTitle id="alert-dialog-title"><Typography align="center"  style={{width:200}}>{errorString}</Typography></DialogTitle>
                <DialogActions>
                    <Button autoFocus 
                        onClick={()=>{
                          if(errorNo === "201"){
                            //navigate("/")
                            document.location.replace(Server3)
                            window.location.replace(Server3)
                          }
                            stateRefresh()
                        }} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        ); 
    }else{
        return(null);
    }
}

export function ConsoleLog(contentString){
    console.log(contentString);
}
//<div style={{height:50, background:"#3F51B5", width: '100%' }}>
export function Topbar(){
    return(
        <div style={{height:50, background:"#3F51B5", width: '100%' }}>
        <img style={{height:50}} src="Image/titlelogo.png"/>
        </div>
    )
}

export const CallAPI = (para,callback) => {
    //Sample:Token, Type(Worker), PhotoID(staffcode.jpg)
    //setIsLoaded(false)
    fetch(Server + Server2,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(para)
    })
      .then(
        res => {
          //ConsoleLog(res)
          const jsonList = res.json();
          if(res.status === 200){
            //ConsoleLog(jsonList)
            //ConsoleLog("200")
            jsonList.then(
              (result) => {
                if(result.length > 0){
                    callback(result)
                }
              }
            )
          }          
          if(res.status === 400){
            //ConsoleLog("400 error");
            jsonList.then(
              (result) => {
                if(result.length > 0){
                  //setErrorNo(result[0]["Error"]);
                  //setError(true);
                }
              }
            )
          }
          return jsonList;
        }
      )
  }

  export const CallDvrAPI = (link,callback) => {
    //Sample:Token, Type(Worker), PhotoID(staffcode.jpg)
    //setIsLoaded(false)
    fetch(link,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(
        res => {
          //ConsoleLog(res)
          const jsonList = res.json();
          if(res.status === 200){
            //ConsoleLog(jsonList)
            //ConsoleLog("200")
            jsonList.then(
              (result) => {
                if(result.length > 0){
                    callback(result)
                }
              }
            )
          }          
          if(res.status === 400){
            //ConsoleLog("400 error");
            jsonList.then(
              (result) => {
                if(result.length > 0){
                  //setErrorNo(result[0]["Error"]);
                  //setError(true);
                }
              }
            )
          }
          return jsonList;
        }
      )
  }

export function GetData(para,callback) {
    // create a new XMLHttpRequest
    var xhr = new XMLHttpRequest()

    // get a callback when the server responds
    xhr.addEventListener('load', () => {
      // update the state of the component with the result here
      //console.log(xhr.responseText)
    })
    xhr.onreadystatechange = function() { // Call a function when the state changes.
        if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
            // Request finished. Do processing here.
            //ConsoleLog(xhr.response);
            const jsonList = JSON.parse(xhr.response);
            callback(jsonList);
        }
    }
    // open the request with the verb and the url
    xhr.open('POST', Server+Server2)
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    // send the request
    xhr.send(para)
  }

  export function TolocalDateString(DateString){//utc to local yyyy-mm-dd HH:MM:SS.000Z
    var DateObject = new Date(DateString+"Z");
    const offset = DateObject.getTimezoneOffset()
    DateObject = new Date(DateObject.getTime() - (offset*60*1000))
    return DateObject.toISOString();
  }

  export function emptyCache(){
    if('caches' in window){
    caches.keys().then((names) => {
            // Delete all the cache files
            names.forEach(name => {
                caches.delete(name);
            })
        });

        // Makes sure the page reloads. Changes are only visible after you refresh.
        //window.location.reload(true);
    }
}